import { Controller } from "stimulus";

// Keeps the "Set my password" button honest.
//
// It used to be permanently pale green with no disabled state, so it read as greyed out even though
// it always submitted, and it never reacted once the two passwords finally matched. Now the muted
// colour means what it looks like, and the button brightens as soon as the password is long enough
// and the confirmation agrees.
//
// Six characters is what the page promises the client and what Firebase actually enforces
// (FirebaseServices::UserUpdater#weak_password?). The server still validates every submission --
// this only spares the client a round-trip and gives the button something to say.
//
// The button is rendered enabled so that a broken or blocked pack leaves a working form rather than
// one nobody can submit; connect() takes it from there.
const MINIMUM_LENGTH = 6;
const READY_CLASS = "bg-actionGreen";
const WAITING_CLASS = "bg-mutedGreen";

export default class extends Controller {
  static targets = ["password", "confirmation", "submit", "mismatch"]

  connect() {
    this.validate();
  }

  validate() {
    const password = this.passwordTarget.value;
    const confirmation = this.confirmationTarget.value;
    const matches = password === confirmation;

    this._setReady(password.length >= MINIMUM_LENGTH && matches);
    // Only complain once there is something to compare, so it stays quiet while they are still typing.
    this.mismatchTarget.classList.toggle("hidden", confirmation.length === 0 || matches);
  }

  _setReady(ready) {
    this.submitTarget.disabled = !ready;
    this.submitTarget.classList.toggle(READY_CLASS, ready);
    this.submitTarget.classList.toggle(WAITING_CLASS, !ready);
  }
}
